import { CB_WALLET_APP_ID, CB_WALLET_TBA_APP_ID } from '@onramp/constants/cbWallets';

export const isWalletApp = (appId: string) => isWalletLegacyApp(appId) || isWalletTbaApp(appId);

export const isWalletTbaApp = (appId: string) => appId === CB_WALLET_TBA_APP_ID;

/** Legacy app is pre-TBA RN app or Chrome extension */
const isWalletLegacyApp = (appId: string) => appId === CB_WALLET_APP_ID;
